/* MTL fix: Slick's "responsive" breakpoints don't reset verticalSwiping when
   vertical is turned off on mobile, which crashes navigation between images
   on the product gallery thumbnails (.js_prod_sub). This keeps verticalSwiping
   in sync with vertical at all times, on load and on breakpoint changes. */
(function ($) {
  function applyFix($el) {
    if (!$el.length || !$el.hasClass('slick-initialized')) return;
    try {
      var slick = $el.slick('getSlick');
      var isMobile = window.matchMedia('(max-width: 575px)').matches;
      slick.slickSetOption('verticalSwiping', !isMobile, true);
    } catch (e) {}
  }

  $(document).ready(function () {
    setTimeout(function () {
      applyFix($('.js_prod_sub'));
    }, 500);

    $('.js_prod_sub').on('breakpoint', function (e, slick, breakpoint) {
      try {
        slick.slickSetOption('verticalSwiping', breakpoint > 575, true);
      } catch (err) {}
    });

    $(window).on('resize', function () {
      applyFix($('.js_prod_sub'));
    });
  });
})(jQuery);
